import {loginClient, apiClient} from "@/service/ApiClient";

export interface SvcUser {
    result: boolean,
    data: SvcUserData,
    message: string
}

export type SvcUserDataRes = {
    code: string,
    data: SvcUserData,
    errors: string[],
    message: string,
    result: boolean
}

export interface SvcUserData {
    userId: number,
    nickName: string,
    token: string,
    refreshToken: string,
    userEmail: string,
    status: string,
    teamId: number,
    teamName: number,
}

export class SvcUserSignUp {
    nickName: string;
    userEmail: string;
    pwd: string;

    constructor(
        nickName: string,
        userEmail: string,
        pwd: string,
    ) {
        this.nickName = nickName;
        this.userEmail = userEmail;
        this.pwd = pwd;
    }
}

export class TermsAggreMents {
    termsAgree: string;             // 서비스 이용
    privateInfoAgree: string;       // 개인정보
    adInfoAgree: string;            // 마케팅
    gpsAgree: string;
    healthSyncAgree: string;

    constructor(termsAgree: string,
                privateInfoAgree: string,
                adInfoAgree: string,
                gpsAgree: string,
                healthSyncAgree: string) {
        this.termsAgree = termsAgree;
        this.privateInfoAgree = privateInfoAgree;
        this.adInfoAgree = adInfoAgree;
        this.gpsAgree = gpsAgree;
        this.healthSyncAgree = healthSyncAgree;
    }
}

export interface ProfileEditReq{
    nickNm: string,
    gender: string,
    birthday: string,
    tall: string,
    pjtNo: number,
    weight: number,
    userEmail: string,
    userMobile: string
}

const getUser = async (userId: number | stirng) =>
    apiClient.get<SvcUser>("/user/"+String(userId)).then(res => res.data)

const deleteUser = async (userId: number) =>
    apiClient.delete<SvcUser>("/user/"+String(userId)).then(res => res)

const signIn = async (uuid:string, mnbrNtrySeCd:string) =>
    loginClient.post("/svcUsers/svcUser/signIn", {'uuid':uuid, 'mnbrNtrySeCd': mnbrNtrySeCd}).then(res => res.data)

const emailSignIn = async (email:string, pwd:string) =>
    loginClient.post("/user/signIn", {'userEmail':email, 'pwd': pwd}).then(res => res)

const signUp = async (svcUserSignUp:SvcUserSignUp) =>
    loginClient.post("/user/signUp", svcUserSignUp).then(res => res)

const checkNickNmDuplicate = async (nickName:string) =>
    loginClient.post<boolean>("/user/nickNameCheck", {'nickName':nickName}).then(res =>res)

const checkEmailDuplicate = async (email:string) =>
    loginClient.post<boolean>("/user/emailCheck", {'userEmail':email}).then(res =>res)

const UserService = {
    getUser
    , deleteUser
    , signIn
    , SvcUserSignUp
    , emailSignIn
    , signUp
    , checkEmailDuplicate
    , checkNickNmDuplicate
}

export default UserService;